import { IconSymbol } from '@uhg-abyss/web/ui/IconSymbol';
import React, { ComponentProps, ReactNode } from 'react';

import { LinkWithTracking } from '../LinkWithTracking/LinkWithTracking';

type AnalyticsInfo = {
  destinationUrl?: string;
  location: string;
  name?: string;
  type?: string;
};

type Props = {
  analyticsInfo?: AnalyticsInfo;
  'aria-label'?: string;
  css?: any;
  'data-auto-testid': string;
  'data-testid': string;
  fontWeight?: 'normal' | 'medium' | 'bold';
  href?: string | null;
  icon?: string | ComponentProps<typeof IconSymbol>['icon'];
  iconSize?: string | ComponentProps<typeof IconSymbol>['size'];
  isDisabled?: boolean;
  onClick: () => any;
  size?: '$xs' | '$sm' | '$md' | '$lg';
  text: any;
  before?: ReactNode | null;
};

export const LinkContainer = ({
  analyticsInfo,
  'aria-label': ariaLabel = '',
  css,
  'data-testid': testId = '',
  'data-auto-testid': dataAutoTestId = '',
  fontWeight = 'bold',
  href = null,
  icon = 'chevron_right',
  iconSize = '$xs',
  isDisabled = false,
  onClick,
  size = '$sm',
  text,
  before = null,
}: Props) => {
  // Only render IconSymbol if icon is a non-empty string
  const afterIcon = icon ? (
    <IconSymbol
      data-auto-testid={testId}
      data-testid={testId}
      icon={icon as ComponentProps<typeof IconSymbol>['icon']}
      size={iconSize}
    />
  ) : null;

  return (
    <React.Fragment>
      <LinkWithTracking
        after={afterIcon}
        analyticsInfo={analyticsInfo}
        aria-label={ariaLabel}
        before={before}
        css={css}
        data-auto-testid={dataAutoTestId}
        data-testid={testId}
        fontWeight={fontWeight}
        href={href ?? undefined}
        isDisabled={isDisabled}
        isStandardAnchor
        onClick={onClick}
        size={size}
      >
        {text}
      </LinkWithTracking>
    </React.Fragment>
  );
};
